module.exports = __webpack_public_path__ + "img/pack.22f7f09f.svg";